import { Approvable } from '../types/adGroups';

export const getApprovedCount = (items: Approvable[]) => {
  let count = 0;
  if (!items) return count;
  items.forEach((item: Approvable) => (count += item.approved ? 1 : 0));
  return count;
};
